<div *ngIf="isIE" class="wrapper" fxLayout="row" fxLayoutAlign="center center">
  It looks like you're using Internet Exporer. Please use an
  <a href="https://browser-update.org/update.html?force_outdated=true" target="_blank"> updated browser.</a>
</div>
